import React from "react";

interface Props {
  cardVerificationError: boolean;
  cardSaveError: boolean;
  subscribeError: boolean;
  subscribeCustomErrorMessage: string;
}

const Errors = ({
  cardVerificationError,
  cardSaveError,
  subscribeError,
  subscribeCustomErrorMessage,
}: Props) => {
  return (
    <>
      {cardVerificationError && (
        <div className="alert alert-danger invalid-card">
          <i className="icon-attention" /> &nbsp;We are unable to verify your
          card. Please check that all of the information is correct.
        </div>
      )}
      {cardSaveError && (
        <div className="alert alert-danger save-card">
          <i className="icon-attention" /> &nbsp;We are unable to save your card
          at this time. Please try again, or contact{" "}
          <a href="/chat/" target="_blank" title="Contact WebstaurantStore">
            Customer Solutions
          </a>{" "}
          for assistance.
        </div>
      )}
      {subscribeError && !subscribeCustomErrorMessage && (
        <div className="alert alert-danger default">
          <i className="icon-attention" /> &nbsp;We are unable to process your
          subscription at this time. Please try again, or contact{" "}
          <a href="/chat/" target="_blank" title="Contact WebstaurantStore">
            Customer Solutions
          </a>{" "}
          for assistance.
        </div>
      )}
      {subscribeError && subscribeCustomErrorMessage && (
        <div className="alert alert-danger default">
          <i className="icon-attention" /> &nbsp;
          {subscribeCustomErrorMessage}
        </div>
      )}
    </>
  );
};

export default Errors;
